import { Alert, AlertContent, AlertDescription, AlertTitle } from '@app/components/ui/alert';
import { Button } from '@app/components/ui/button';

import { AlertCircle } from 'lucide-react';

type ErrorFallbackProps = {
  error: unknown;
  resetErrorBoundary?: () => void;
};

function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const errorMessage = error instanceof Error ? error.message : String(error ?? '');

  return (
    <Alert variant="destructive" role="alert" data-testid="error-fallback">
      <AlertCircle className="h-4 w-4" />
      <AlertContent className="w-full">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <AlertTitle>Something went wrong</AlertTitle>
            <AlertDescription>
              Try again or reload the page. If this keeps happening, please contact
              support@promptfoo.dev.
            </AlertDescription>
          </div>
          <div className="flex shrink-0 gap-2">
            {resetErrorBoundary ? (
              <Button type="button" variant="outline" size="sm" onClick={resetErrorBoundary}>
                Try again
              </Button>
            ) : null}
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() => window.location.reload()}
            >
              Reload page
            </Button>
          </div>
        </div>
        {errorMessage ? (
          <pre className="mt-3 overflow-auto whitespace-pre-wrap rounded-md border border-border/60 bg-background/60 p-2 text-xs font-mono">
            {errorMessage}
          </pre>
        ) : null}
      </AlertContent>
    </Alert>
  );
}

export default ErrorFallback;
